import { render, staticRenderFns } from "./activeProducts.vue?vue&type=template&id=b4dc9ec8&"
import script from "./activeProducts.vue?vue&type=script&lang=js&"
export * from "./activeProducts.vue?vue&type=script&lang=js&"
import style0 from "./activeProducts.vue?vue&type=style&index=0&id=b4dc9ec8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports